(function(){
'use strict';
var RM=matchMedia('(prefers-reduced-motion: reduce)').matches;
var money=function(c){return (c/100).toFixed(2).replace('.',',')+' €'};
window.CCmoney=money;

/* Toast */
window.CCtoast=function(msg){var t=document.getElementById('toast');if(!t)return;
 t.textContent=msg;t.classList.add('show');clearTimeout(t._h);t._h=setTimeout(function(){t.classList.remove('show')},1900);};

/* Cart-Badge */
function setBadges(n){document.querySelectorAll('[data-cart-count]').forEach(function(el){
 el.textContent=n;el.classList.remove('bump');void el.offsetWidth;el.classList.add('bump');});}
window.CCvalidatePromo=window.CCvalidatePromo||function(code){code=String(code||'').trim().toUpperCase();
 if(!/^[A-Z0-9][A-Z0-9-]{2,19}$/.test(code))return{ok:false,msg:'Bitte gib einen g\u00fcltigen Code ein'};
 return{ok:true,code:code,label:'Wird im Checkout eingel\u00f6st',disc:0,freeShip:false};};
window.CCrefreshCart=function(){return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){setBadges(c.item_count);return c;});};

/* Klickpunkt für Fly-to-Cart */
var LASTPT=null;
document.addEventListener('pointerdown',function(e){LASTPT={x:e.clientX,y:e.clientY,t:Date.now()}},{capture:true,passive:true});
function flyToCart(img){
 if(RM||!LASTPT||Date.now()-LASTPT.t>1500||!img)return;
 var target=document.querySelector('[data-cart-target]');if(!target)return;
 var tr=target.getBoundingClientRect();
 var el=document.createElement('div');el.className='fly2cart';
 el.style.backgroundImage='url("'+img+'")';
 el.style.left=(LASTPT.x-21)+'px';el.style.top=(LASTPT.y-21)+'px';
 document.body.appendChild(el);
 var dx=(tr.left+tr.width/2)-LASTPT.x,dy=(tr.top+tr.height/2)-LASTPT.y;
 el.animate([{transform:'translate(0,0) scale(1)',opacity:1},
  {transform:'translate('+(dx*0.5)+'px,'+(dy*0.5-110)+'px) scale(.75)',opacity:1,offset:.55},
  {transform:'translate('+dx+'px,'+dy+'px) scale(.15)',opacity:.4}],
  {duration:640,easing:'cubic-bezier(.3,.85,.35,1)'}).onfinish=function(){el.remove()};
}

/* AJAX Add-to-Cart */
window.CCadd=function(variantId,qty,props,img,name,plan){
 var body={items:[{id:Number(variantId),quantity:qty||1}]};
 if(props)body.items[0].properties=props;
 if(plan)body.items[0].selling_plan=Number(plan)||plan;
 return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)})
  .then(function(r){if(!r.ok)throw r;return r.json()})
  .then(function(){flyToCart(img);return CCrefreshCart();})
  .then(function(){if(window.CCdrawerOpen){setTimeout(window.CCdrawerOpen,420)}else{CCtoast((name||'Produkt')+' wurde in den Warenkorb gelegt ✓')}})
  .catch(function(){CCtoast('Konnte nicht hinzugefügt werden');});
};
document.addEventListener('click',function(e){
 var b=e.target.closest('[data-add-variant]');if(!b)return;
 e.preventDefault();
 CCadd(b.getAttribute('data-add-variant'),Number(b.getAttribute('data-qty')||1),null,b.getAttribute('data-img'),b.getAttribute('data-name'),b.getAttribute('data-plan'));
});

/* Reveals */
var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target)}})},{threshold:.12});
function observe(){document.querySelectorAll('.rv:not(.in)').forEach(function(el){
 var p=el.parentElement;
 if(p&&/(coll-grid|box-grid|builder-grid|moments-grid|stats|ed-strip)/.test(p.className)){
  var ix=[].indexOf.call(p.children,el);el.style.transitionDelay=(Math.min(ix,7)*70)+'ms';}
 io.observe(el)})}
observe();document.addEventListener('shopify:section:load',observe);

/* Nav / Menü / Scroll */
function onScrollFrame(){
 var nav=document.querySelector('nav.float');if(nav)nav.classList.toggle('scrolled',scrollY>40);
 var tt=document.getElementById('toTop');if(tt)tt.classList.toggle('show',scrollY>640);
 var ab=document.getElementById('abBar');
 if(nav)nav.style.top=(ab&&!ab.classList.contains('hide')?Math.max(14,52-scrollY):14)+'px';
 var h=document.documentElement,p=h.scrollTop/((h.scrollHeight-h.clientHeight)||1);
 var sp=document.getElementById('scrollProg');if(sp)sp.style.width=(p*100)+'%';
}
addEventListener('scroll',onScrollFrame,{passive:true});
onScrollFrame();
document.addEventListener('click',function(e){
 if(e.target.closest('[data-menu-open]')){document.getElementById('msheet').classList.add('open')}
 if(e.target.closest('[data-menu-close]')||e.target.closest('.msheet a')){var m=document.getElementById('msheet');if(m)m.classList.remove('open')}
});

/* Pointer-Specular auf Glas */
document.addEventListener('pointermove',function(e){
 var g=e.target.closest?e.target.closest('.glass'):null;if(!g)return;
 var r=g.getBoundingClientRect();
 g.style.setProperty('--gx',((e.clientX-r.left)/r.width*100)+'%');
 g.style.setProperty('--gy',((e.clientY-r.top)/r.height*100)+'%');
},{passive:true});

/* Karten-Tilt */
var TILT=matchMedia('(hover:hover)').matches&&!RM;
document.addEventListener('pointermove',function(e){
 if(!TILT)return;
 var c=e.target.closest?e.target.closest('.coll,.boxc'):null;if(!c)return;
 var r=c.getBoundingClientRect();
 var rx=((e.clientY-r.top)/r.height-0.5)*-5,ry=((e.clientX-r.left)/r.width-0.5)*5;
 c.style.transform='translateY(-8px) perspective(800px) rotateX('+rx.toFixed(2)+'deg) rotateY('+ry.toFixed(2)+'deg)';
},{passive:true});
document.addEventListener('pointerout',function(e){
 var c=e.target.closest?e.target.closest('.coll,.boxc'):null;
 if(c&&!c.contains(e.relatedTarget))c.style.transform='';
},{passive:true});

/* Hero-Wort-Stagger */
function heroStagger(){
 if(RM)return;
 document.querySelectorAll('[data-hero-title]:not([data-st])').forEach(function(h){
  h.dataset.st='1';
  h.innerHTML=h.innerHTML.split('<br>').map(function(line){
   return line.trim().split(' ').map(function(w,i){return '<span class="hw" style="animation-delay:'+(0.08+i*0.09)+'s">'+w+'</span>'}).join(' ');
  }).join('<br>');
 });
}
heroStagger();document.addEventListener('shopify:section:load',heroStagger);

/* Bestseller-Slider */
function sliderInit(root){
 var track=root.querySelector('[data-track]');if(!track)return;
 var n=track.children.length,i=0,t=null;
 function go(k){i=((k%n)+n)%n;track.style.transform='translateX(-'+(i*100)+'%)';
  root.querySelectorAll('[data-dot]').forEach(function(d,ix){d.classList.toggle('on',ix===i)});auto();}
 function auto(){clearInterval(t);t=setInterval(function(){go(i+1)},4600);}
 root.querySelectorAll('[data-dot]').forEach(function(d,ix){d.addEventListener('click',function(){go(ix)})});
 root.querySelectorAll('[data-nav]').forEach(function(b){b.addEventListener('click',function(){go(i+Number(b.dataset.nav))})});
 root.addEventListener('pointerenter',function(){clearInterval(t)});
 root.addEventListener('pointerleave',auto);
 var sx=null;
 root.addEventListener('pointerdown',function(e){sx=e.clientX},{passive:true});
 root.addEventListener('pointerup',function(e){if(sx===null)return;var d=e.clientX-sx;sx=null;if(Math.abs(d)>42)go(i+(d<0?1:-1))},{passive:true});
 go(0);
}
function initSliders(){document.querySelectorAll('[data-bs-slider]:not([data-init])').forEach(function(r){r.dataset.init='1';sliderInit(r)})}
initSliders();document.addEventListener('shopify:section:load',initSliders);


/* ===== v1.1.2: Bild- & Video-Fallbacks (Marken-Placeholder statt Löcher) ===== */
function fbData(label){
 var c=document.createElement('canvas');c.width=c.height=480;var g=c.getContext('2d');
 var r=g.createRadialGradient(210,190,50,240,240,220);
 r.addColorStop(0,'#E3B276');r.addColorStop(.72,'#C8935A');r.addColorStop(1,'#A9743F');
 g.fillStyle=r;g.beginPath();g.arc(240,240,216,0,7);g.fill();
 g.strokeStyle='rgba(120,75,35,.5)';g.lineWidth=9;g.beginPath();g.arc(240,240,210,0,7);g.stroke();
 [[140,150,27],[310,130,23],[225,285,29],[140,320,20],[340,300,25],[240,180,15]].forEach(function(p2){
  g.fillStyle='#4A2B18';g.beginPath();g.arc(p2[0],p2[1],p2[2],0,7);g.fill();});
 if(label){g.fillStyle='rgba(255,255,255,.92)';g.font='700 34px Figtree,Arial';g.textAlign='center';
  var t=String(label).split(' ')[0].slice(0,12);g.fillText(t,240,420);}
 return c.toDataURL('image/png');
}
function fbPack(city){
 var c=document.createElement('canvas');c.width=300;c.height=386;var g=c.getContext('2d');
 function rr(x,y,w,h,r){g.beginPath();g.moveTo(x+r,y);g.arcTo(x+w,y,x+w,y+h,r);g.arcTo(x+w,y+h,x,y+h,r);g.arcTo(x,y+h,x,y,r);g.arcTo(x,y,x+w,y,r);g.closePath();}
 var gr=g.createLinearGradient(0,0,0,386);gr.addColorStop(0,'#16355F');gr.addColorStop(.55,'#0E2547');gr.addColorStop(1,'#0A1F3D');
 rr(24,12,252,362,16);g.fillStyle=gr;g.fill();
 g.strokeStyle='rgba(255,255,255,.4)';g.lineWidth=2.5;rr(24,12,252,362,16);g.stroke();
 g.strokeStyle='rgba(201,169,59,.9)';g.lineWidth=2;rr(34,22,232,342,12);g.stroke();
 g.fillStyle='#081A33';g.fillRect(24,12,252,30);g.fillRect(24,344,252,30);
 g.fillStyle='#FCFAF3';g.beginPath();g.arc(150,140,58,0,7);g.fill();
 g.fillStyle='#26375F';g.beginPath();g.arc(150,124,22,0,7);g.fill();
 g.fillStyle='#FCFAF3';g.beginPath();g.arc(165,115,9,0,7);g.fill();
 g.fillStyle='#26375F';g.textAlign='center';g.font='600 18px Georgia,serif';g.fillText('THE COOKIE',150,166);
 g.font='500 12px Georgia,serif';g.fillText('— C L U B —',150,182);
 g.fillStyle='#D9B262';g.font='700 26px Georgia,serif';g.fillText(String(city||'').toUpperCase().slice(0,13),150,258);
 g.fillStyle='rgba(217,178,98,.92)';g.font='600 11px Figtree,Arial';g.fillText('SIGNATURE EDITION',150,282);
 return c.toDataURL('image/png');
}
document.addEventListener('error',function(e){
 var t=e.target;
 if(t&&t.tagName==='IMG'){
  if(!t.dataset.rq&&t.src.indexOf('data:')!==0&&t.src.indexOf('?')>-1){t.dataset.rq='1';t.src=t.src.split('?')[0];return;}
  if(!t.dataset.fb){t.dataset.fb='1';t.classList.add('ld');
   t.src=t.dataset.fbpack?fbPack(t.dataset.fbpack):fbData(t.alt);}
 }
 if(t&&(t.tagName==='SOURCE'||t.tagName==='VIDEO')){
  var v=t.tagName==='VIDEO'?t:t.parentElement;
  if(v&&v.tagName==='VIDEO')v.classList.add('vfail');}
},true);
/* ===== v1.1: Bild-Fade ===== */
function imgFade(){document.querySelectorAll('img:not([data-if])').forEach(function(im){
 im.setAttribute('data-if','1');
 if(im.complete)return;
 im.classList.add('imgfade');
 im.addEventListener('load',function(){im.classList.add('ld')},{once:true});
 im.addEventListener('error',function(){im.classList.add('ld')},{once:true});});}
imgFade();document.addEventListener('shopify:section:load',imgFade);

/* ===== v1.1: Nach-oben-Button ===== */
(function(){var tt=document.createElement('button');tt.id='toTop';tt.innerHTML='↑';
 tt.setAttribute('aria-label','Nach oben scrollen');document.body.appendChild(tt);
 tt.addEventListener('click',function(){scrollTo({top:0,behavior:RM?'auto':'smooth'})});})();

/* ===== v1.1: Ankündigungsleiste ===== */
(function(){var ab=document.getElementById('abBar');if(!ab)return;
 var hidden=false;try{hidden=sessionStorage.getItem('ccAb')==='0'}catch(e){}
 if(hidden){ab.classList.add('hide');return}
 var ms=ab.querySelectorAll('.ab-m'),i=0;
 if(ms.length>1)setInterval(function(){ms[i].classList.remove('on');i=(i+1)%ms.length;ms[i].classList.add('on')},3800);
 var x=ab.querySelector('[data-ab-close]');
 if(x)x.addEventListener('click',function(){ab.classList.add('hide');
  var nav=document.querySelector('nav.float');if(nav)nav.style.top='14px';
  try{sessionStorage.setItem('ccAb','0')}catch(e){}});
})();

/* ===== v1.1: Zähler ===== */
(function(){
 var cio=new IntersectionObserver(function(es){es.forEach(function(en){
  if(!en.isIntersecting)return;cio.unobserve(en.target);
  var el=en.target,raw=el.getAttribute('data-count'),t=parseFloat(raw.replace(',','.')),
      dec=Number(el.getAttribute('data-dec')||0),s=performance.now();
  if(RM||isNaN(t)){el.textContent=raw;return}
  (function step(n){var k=Math.min(1,(n-s)/1300),e2=1-Math.pow(1-k,3);
   el.textContent=(t*e2).toFixed(dec).replace('.',',');
   if(k<1)requestAnimationFrame(step)})(s);
 })},{threshold:.5});
 function watch(){document.querySelectorAll('[data-count]:not([data-c])').forEach(function(el){el.setAttribute('data-c','1');cio.observe(el)})}
 watch();document.addEventListener('shopify:section:load',watch);
})();

/* ===== v1.1: PDP-Galerie ===== */
document.addEventListener('click',function(e){
 var th=e.target.closest('.pth');if(!th)return;
 var main=document.getElementById('pdpMain');if(!main)return;
 document.querySelectorAll('.pth').forEach(function(b){b.classList.remove('on')});
 th.classList.add('on');
 main.style.opacity='0';
 setTimeout(function(){main.onload=function(){main.style.opacity='1'};main.src=th.getAttribute('data-src')},170);
});

/* ===== v1.1: Sticky-Kaufleiste (mobil) ===== */
(function(){
 var form=document.querySelector('.pdp form[action*="/cart/add"]');if(!form)return;
 var priceEl=document.querySelector('.pdp-price');
 var bar=document.createElement('div');bar.id='pdpBar';bar.className='glass-dark';
 var pTxt=priceEl?priceEl.childNodes[0].textContent.trim():'';
 bar.innerHTML='<span>'+pTxt+'</span><button class="btn btn-white" type="button">In den Warenkorb</button>';
 document.body.appendChild(bar);
 bar.querySelector('button').addEventListener('click',function(){
  form.requestSubmit?form.requestSubmit():form.submit()});
 var buy=form.querySelector('.buy-row')||form;
 new IntersectionObserver(function(es){
  bar.classList.toggle('show',!es[0].isIntersecting&&innerWidth<=840);
 },{threshold:0}).observe(buy);
})();

/* ===== v1.1: Warenkorb-Drawer ===== */
var CD={el:null};
CD.init=function(){CD.el=document.getElementById('cartDrawer');if(!CD.el)return;
 window.CCdrawerOpen=CD.open;
 document.addEventListener('click',function(e){
  var t=e.target.closest('[data-cart-target]');
  if(t){e.preventDefault();CD.open();return}
  if(e.target.closest('[data-cd-close]')){CD.close();return}
  var mi=e.target.closest('[data-cd-minus]');if(mi){CD.change(Number(mi.getAttribute('data-cd-minus')),-1);return}
  var pl=e.target.closest('[data-cd-plus]');if(pl){CD.change(Number(pl.getAttribute('data-cd-plus')),1);return}
  var rm=e.target.closest('[data-cd-rm]');if(rm){CD.set(Number(rm.getAttribute('data-cd-rm')),0);return}
  if(e.target.closest('[data-cd-apply]')){CD.apply(e.target.closest('.cd-promo'));return}
  if(e.target.closest('[data-cd-uncode]')){CD.setPromo(null);return}
  if(e.target.closest('[data-cd-notetgl]')){var nt=document.querySelector('[data-cd-note]');if(nt){nt.hidden=!nt.hidden;if(!nt.hidden)nt.focus()}return}
  if(e.target.closest('[data-cd-checkout],[data-cc-checkout]')){e.preventDefault();CD.checkout();return}
 });
 document.addEventListener('keydown',function(e){if(e.key==='Escape')CD.close()});
 document.addEventListener('change',function(e){if(e.target.matches&&e.target.matches('[data-cd-note]')){
  var v=e.target.value;
  (window.CCsaveNote||function(n){fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
   body:JSON.stringify({note:n})}).then(function(){CCtoast('Nachricht gespeichert \u2713')}).catch(function(){})})(v);}});
};
CD.open=function(){if(!CD.el)return;CD.el.classList.add('open');CD.el.setAttribute('aria-hidden','false');
 document.documentElement.classList.add('cc-drawer-open');
 document.documentElement.style.overflow='hidden';CD.refresh();};
CD.close=function(){if(!CD.el)return;CD.el.classList.remove('open');CD.el.setAttribute('aria-hidden','true');
 document.documentElement.classList.remove('cc-drawer-open');
 document.documentElement.style.overflow='';};
CD.refresh=function(){fetch('/cart.js').then(function(r){return r.json()}).then(CD.render)};
CD.qtyMap={};
CD.change=function(line,d){var q=(CD.qtyMap[line]||1)+d;CD.set(line,Math.max(0,q))};
CD.set=function(line,q){
 fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
  body:JSON.stringify({line:line,quantity:q})})
 .then(function(r){return r.json()})
 .then(function(c){CD.render(c);setBadges(c.item_count)})
 .catch(function(){CCtoast('Aktualisierung fehlgeschlagen')});};
CD.promo=null;CD.lastCart=null;
try{CD.promo=JSON.parse(sessionStorage.getItem('cc_promo')||'null')}catch(e){}
CD.setPromo=function(p){CD.promo=p;
 try{p?sessionStorage.setItem('cc_promo',JSON.stringify(p)):sessionStorage.removeItem('cc_promo')}catch(e){}
 if(CD.lastCart)CD.sums(CD.lastCart);else CD.chips();};
CD.chips=function(){document.querySelectorAll('.cd-promo').forEach(function(root){
 var chip=root.querySelector('[data-cd-chip]'),err=root.querySelector('[data-cd-err]'),inp=root.querySelector('[data-cd-code]'),row=root.querySelector('.row');
 if(err)err.hidden=true;
 if(CD.promo){if(chip){chip.hidden=false;chip.querySelector('[data-cd-chipcode]').textContent=CD.promo.code;
  chip.querySelector('[data-cd-chiptxt]').textContent=CD.promo.label||'';}
  if(row)row.style.display='none';}
 else{if(chip)chip.hidden=true;if(row)row.style.display='';if(inp)inp.value='';}});};
CD.apply=function(root){root=root||CD.el;if(!root)return;var inp=root.querySelector('[data-cd-code]');if(!inp)return;
 var res=window.CCvalidatePromo(inp.value,(CD.lastCart||{}).total_price||0);
 var err=root.querySelector('[data-cd-err]');
 if(!res.ok){if(err){err.hidden=false;err.textContent=res.msg||'Code ung\u00fcltig'}
  root.classList.add('shake');setTimeout(function(){root.classList.remove('shake')},450);return}
 CD.setPromo(res);CCtoast('Code '+res.code+' aktiviert \u2713');};
CD.sums=function(c){var q=function(sel){return CD.el?CD.el.querySelector(sel):null};
 var sub=c.total_price,disc=0;
 if(CD.promo){disc=CD.promo.pct?Math.round(sub*CD.promo.pct/100):Math.min(sub,Math.round(CD.promo.disc||0));}
 var free=Number(document.body.getAttribute('data-free-shipping')||49)*100;
 var shipBase=Math.round(parseFloat(document.body.getAttribute('data-shipping-cost')||'4.9')*100);
 var after=sub-disc;
 var freeShip=after>=free||!!(CD.promo&&CD.promo.freeShip);
 var ship=!c.items.length?null:(freeShip?0:shipBase);
 var el;
 if(el=q('[data-cd-sub]'))el.textContent=money(sub);
 var dr=q('[data-cd-discrow]');
 if(dr){var showD=!!(CD.promo&&disc>0);dr.hidden=!showD;
  if(showD){q('[data-cd-disclabel]').textContent='Rabatt ('+CD.promo.code+')';q('[data-cd-disc]').textContent='\u2212'+money(disc);}}
 if(el=q('[data-cd-shipcost]'))el.textContent=ship===null?'\u2014':(ship===0?'Gratis':money(ship));
 if(el=q('[data-cd-total]'))el.textContent=money(after+(ship||0));
 var gift=Number(document.body.getAttribute('data-free-gift')||0)*100;
 var giftOn=gift>0&&c.items.length>0&&after>=gift;
 var track=gift>free?gift:free;
 if(el=q('[data-cd-bar]'))el.style.width=(c.items.length?Math.min(100,Math.round(after/track*100)):0)+'%';
 var ms=q('[data-ms=ship]');if(ms){ms.style.left=Math.round(free/track*100)+'%';ms.classList.toggle('done',c.items.length>0&&freeShip);}
 var mg=q('[data-ms=gift]');if(mg){mg.style.left='100%';mg.classList.toggle('done',giftOn);}
 var gr=q('[data-cd-gift]');if(gr)gr.hidden=!giftOn;
 var stxt='';
 if(c.items.length){
  if(giftOn)stxt='\ud83c\udf6a Gratis-Cookie gesichert \u00b7 \ud83c\udf89 Versandkostenfrei!';
  else if(freeShip)stxt='\ud83c\udf89 Versandkostenfrei!'+(gift>0?(' Noch '+money(gift-after)+' bis zum Gratis-Cookie \ud83c\udf6a'):'');
  else stxt='Noch '+money(free-after)+' bis zum Gratisversand';
 }
 if(el=q('[data-cd-ship]'))el.textContent=stxt;
 CD.calc={sub:sub,disc:disc,ship:ship===null?0:ship,total:after+(ship||0),freeShip:freeShip,giftOn:giftOn};
 CD.chips();};
CD.checkout=function(){
 if(window.CCcheckout){window.CCcheckout();return}
 var url='/checkout';
 if(CD.promo&&CD.promo.code)url='/discount/'+encodeURIComponent(CD.promo.code)+'?redirect=%2Fcheckout';
 location.href=url;};
CD.render=function(c){if(!CD.el)return;CD.qtyMap={};CD.lastCart=c;
 var lines=CD.el.querySelector('[data-cd-lines]');
 if(!c.items.length){lines.innerHTML='<div class="cd-empty">🍪<br>Noch keine Cookies drin.<br><a class="btn btn-white" href="#build" data-cd-close>Box befüllen</a></div>'}
 else{lines.innerHTML=c.items.map(function(it,ix){
  CD.qtyMap[ix+1]=it.quantity;
  var props=Object.keys(it.properties||{}).filter(function(k){return k.charAt(0)!=='_'})
   .map(function(k){return k+': '+it.properties[k]}).join(' · ');
  return '<div class="cd-line">'+
   (it.image?'<img src="'+it.image+'" alt="">':'<span class="cd-ph">🍪</span>')+
   '<div class="ct"><b>'+it.product_title+'</b>'+(props?'<span>'+props+'</span>':'')+
   '<div class="cd-q"><button data-cd-minus="'+(ix+1)+'" aria-label="Weniger">−</button><i>'+it.quantity+
   '</i><button data-cd-plus="'+(ix+1)+'" aria-label="Mehr">+</button>'+
   '<button class="cd-rm" data-cd-rm="'+(ix+1)+'">Entfernen</button></div></div>'+
   '<b class="cp">'+money(it.final_line_price)+'</b></div>'}).join('')}
 CD.sums(c);
 var up=CD.el.querySelector('[data-cd-upsell]');if(up)up.hidden=!c.items.length;
};
CD.init();
window.CD=CD;


CCrefreshCart();
})();

/* ===== Midnight Mode: Hell = Standard, Auto-Umschaltung nach Mitternacht ===== */
(function(){var K='cc-mode',R=document.documentElement;
function attr(n,d){var b=document.body;if(!b)return d;var v=b.getAttribute(n);return v===null?d:v}
function autoMid(){if(attr('data-mid-auto','1')!=='1')return false;
 var f=+attr('data-mid-from',0),t=+attr('data-mid-to',6),h=new Date().getHours();
 return f<t?(h>=f&&h<t):(h>=f||h<t)}
function mode(){var s=null;try{s=sessionStorage.getItem(K)}catch(e){}
 if(s==='mid'||s==='day')return s;return autoMid()?'mid':'day'}
function ap(){var m=mode();R.classList.toggle('cc-mid',m==='mid');
 document.querySelectorAll('[data-mid-toggle]').forEach(function(b){b.textContent=m==='mid'?'\u2600':'\u263e'})}
document.addEventListener('click',function(e){var b=e.target.closest('[data-mid-toggle]');if(!b)return;
 var m=R.classList.contains('cc-mid')?'day':'mid';try{sessionStorage.setItem(K,m)}catch(e){}ap()});
document.addEventListener('DOMContentLoaded',ap);ap();
setInterval(ap,60000);
})();

/* ===== v2.1: Frisch-Versprechen ===== */
(function(){
function tick(){document.querySelectorAll('[data-fresh]').forEach(function(el){
 var cut=Number(el.getAttribute('data-fresh-cutoff')||14),now=new Date();
 var tgt=new Date(now);tgt.setHours(cut,0,0,0);
 var late=false;if(tgt<=now){late=true;tgt.setDate(tgt.getDate()+1)}
 var ms=tgt-now,h=Math.floor(ms/3600000),m=Math.floor(ms%3600000/60000);
 var t=(h>0?h+' h ':'')+m+' min';
 var tpl=el.getAttribute(late?'data-fresh-late':'data-fresh-pre')||'{t}';
 var out=el.querySelector('[data-fresh-txt]');if(out)out.textContent=tpl.replace('{t}',t);});}
tick();setInterval(tick,30000);
})();

/* ===== v2.1: Live-Suche (Predictive Search) ===== */
(function(){var so=document.getElementById('searchOverlay');if(!so)return;
var q=so.querySelector('[data-so-q]'),res=so.querySelector('[data-so-res]'),all=so.querySelector('[data-so-all]');
function open(){so.classList.add('open');so.setAttribute('aria-hidden','false');setTimeout(function(){q.focus()},60)}
function close(){so.classList.remove('open');so.setAttribute('aria-hidden','true')}
document.addEventListener('click',function(e){
 if(e.target.closest('[data-so-open]')){e.preventDefault();open();return}
 if(e.target.closest('[data-so-close]'))close();});
document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
var t=null;
q.addEventListener('input',function(){clearTimeout(t);var v=q.value.trim();
 if(all)all.href='/search?q='+encodeURIComponent(v);
 if(v.length<2){res.innerHTML='';return}
 t=setTimeout(function(){
  fetch('/search/suggest.json?q='+encodeURIComponent(v)+'&resources[type]=product&resources[limit]=6')
  .then(function(r){return r.json()})
  .then(function(d){var ps=(((d||{}).resources||{}).results||{}).products||[];
   if(!ps.length){res.innerHTML='<div class="so-hint">Nichts gefunden – anders probieren?</div>';return}
   res.innerHTML=ps.map(function(p){return '<a class="so-item" href="'+p.url+'">'+
    (p.image?'<img src="'+p.image+'" alt="">':'<span class="cd-ph">🍪</span>')+
    '<b>'+p.title+'</b><span>'+(p.price||'')+'</span></a>'}).join('');})
  .catch(function(){res.innerHTML='<div class="so-hint">Live-Suche gerade nicht erreichbar – Enter drücken für die Suchseite.</div>'});},260);});
})();

/* ===== v2.3: Abo — Plan wählen & starten (ohne Sperren) ===== */
(function(){
document.querySelectorAll('[data-abo]').forEach(function(root){
 var sel=null;
 function pick(card){root.querySelectorAll('[data-abo-plan]').forEach(function(c){c.classList.remove('sel')});
  card.classList.add('sel');
  sel={label:card.getAttribute('data-label'),price:card.getAttribute('data-price'),
       variant:card.getAttribute('data-variant'),plan:card.getAttribute('data-plan')};
  var l=root.querySelector('[data-abo-sum-label]'),pr=root.querySelector('[data-abo-sum-price]');
  if(l)l.textContent=sel.label;if(pr&&sel.price)pr.textContent=sel.price;}
 var pre=root.querySelector('[data-abo-plan].pop')||root.querySelector('[data-abo-plan]');
 if(pre)pick(pre);
 root.addEventListener('click',function(e){
  var card=e.target.closest('[data-abo-plan]');if(card){pick(card);return}
  var go=e.target.closest('[data-abo-start]');
  if(go){if(!sel){CCtoast('Bitte einen Plan wählen');return}
   if(sel.variant&&sel.plan){CCadd(sel.variant,1,null,null,'Monthly Drop · '+sel.label,sel.plan)}
   else{location.href=go.getAttribute('data-fallback')||'/collections/all'}}});
});
})();

/* ===== v2.4: Store-Live-Badge ===== */
(function(){
function parse(code){return String(code||'').split(';').map(function(g){
 var m=g.match(/^(\d)(?:-(\d))?:(\d{2})(\d{2})-(\d{2})(\d{2})$/);if(!m)return null;
 return{a:+m[1],b:+(m[2]||m[1]),o:+m[3]*60+ +m[4],c:+m[5]*60+ +m[6]};}).filter(Boolean);}
function tick(){var now=new Date(),dow=now.getDay()||7,min=now.getHours()*60+now.getMinutes();
 document.querySelectorAll('[data-store-open]').forEach(function(el){
  var rules=parse(el.getAttribute('data-hours')),today=null;
  rules.forEach(function(r){if(dow>=r.a&&dow<=r.b)today=r});
  if(today&&min>=today.o&&min<today.c){
   el.classList.add('open');el.classList.remove('closed');
   el.textContent='Jetzt geöffnet · bis '+String(Math.floor(today.c/60)).padStart(2,'0')+':'+String(today.c%60).padStart(2,'0');
  }else{el.classList.add('closed');el.classList.remove('open');
   el.textContent=(today&&min<today.o)?('Öffnet heute '+String(Math.floor(today.o/60)).padStart(2,'0')+':'+String(today.o%60).padStart(2,'0')):'Gerade geschlossen';}});}
tick();setInterval(tick,60000);
})();

/* ===== v2.4: Newsletter-Popup ===== */
(function(){var np=document.getElementById('npPop');if(!np)return;
var K='cc_np_ts',days=Number(np.getAttribute('data-np-days')||7),delay=Number(np.getAttribute('data-np-delay')||20)*1000;
function seen(){try{var t=Number(localStorage.getItem(K)||0);return t&&(Date.now()-t)<days*864e5}catch(e){return false}}
function mark(){try{localStorage.setItem(K,String(Date.now()))}catch(e){}}
function open(done){np.classList.add('open');np.setAttribute('aria-hidden','false');
 if(done){var f=np.querySelector('[data-np-form]'),d=np.querySelector('[data-np-done]');
  if(f)f.hidden=true;if(d)d.hidden=false;}}
function close(){np.classList.remove('open');np.setAttribute('aria-hidden','true');mark();}
document.addEventListener('click',function(e){
 if(e.target.closest('[data-np-close]')){close();return}
 var cp=e.target.closest('[data-np-copy]');
 if(cp){var c=np.querySelector('[data-np-code]');if(!c)return;
  var t=c.textContent.trim();
  if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(t).then(function(){CCtoast('Code kopiert ✓')})}
  else{CCtoast(t)}}});
if(/customer_posted=true/.test(location.search)){open(true);mark();}
else if(!seen()){setTimeout(function(){open(false)},delay);}
})();

/* ===== v2.5a: Karten-Tilt + Gold-Glanz ===== */
(function(){
if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
if(document.body.getAttribute('data-fx-tilt')==='0')return;
var fine=matchMedia('(pointer: fine)').matches;
var SEL='.coll,.ed,.boxc,.bs-card,.mc,.abop-card,.store-card,.how-card';
function arm(){document.querySelectorAll(SEL).forEach(function(c){
 if(c.dataset.fx)return;c.dataset.fx='1';c.classList.add('fx-tilt');
 var g=document.createElement('i');g.className='fx-glare';c.appendChild(g);
 if(!fine)return;var raf=null;
 c.addEventListener('pointerenter',function(){c.style.transition='transform .09s ease-out'});
 c.addEventListener('pointermove',function(e){
  var r=c.getBoundingClientRect(),x=(e.clientX-r.left)/r.width,y=(e.clientY-r.top)/r.height;
  if(raf)return;raf=requestAnimationFrame(function(){raf=null;
   c.style.transform='perspective(750px) rotateX('+((.5-y)*7).toFixed(2)+'deg) rotateY('+((x-.5)*9).toFixed(2)+'deg) translateY(-4px)';
   c.style.setProperty('--gx',(x*100).toFixed(1)+'%');c.style.setProperty('--gy',(y*100).toFixed(1)+'%');
   g.style.opacity='1';});});
 c.addEventListener('pointerleave',function(){if(raf){cancelAnimationFrame(raf);raf=null}
  c.style.transition='transform .45s cubic-bezier(.2,.8,.2,1)';c.style.transform='';g.style.opacity='0';});});}
arm();setInterval(arm,1200);
})();

/* ===== v2.5b: Split-Flap-Countdown ===== */
(function(){
if(document.body.getAttribute('data-fx-flap')==='0')return;
var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
function wire(el){if(el.dataset.flap)return;el.dataset.flap='1';var last=el.textContent;
 function render(txt,mask){el.dataset.lock='1';el.textContent='';
  for(var i=0;i<txt.length;i++){var s=document.createElement('span');s.className='fd';
   s.textContent=txt.charAt(i);if(!reduce&&mask&&mask[i])s.classList.add('flip');
   el.appendChild(s);}delete el.dataset.lock;}
 render(last,null);
 new MutationObserver(function(){if(el.dataset.lock)return;
  var t=el.textContent;if(t===last)return;
  var mask=[];for(var i=0;i<t.length;i++)mask[i]=t.charAt(i)!==last.charAt(i);
  last=t;render(t,mask);}).observe(el,{childList:true,characterData:true,subtree:true});}
function arm(){document.querySelectorAll('[data-dc],[data-ab-count]').forEach(wire)}
arm();setInterval(arm,1500);
})();

/* ===== v2.5c: Sanfte Seitenübergänge ===== */
(function(){
if(document.body.getAttribute('data-fx-page')==='0')return;
if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
var main=document.getElementById('MainContent')||document.querySelector('main');
if(main)main.classList.add('pg-in');
document.addEventListener('click',function(e){
 var a=e.target.closest('a[href]');if(!a)return;
 var h=a.getAttribute('href')||'';
 if(a.target||a.hasAttribute('download')||h.charAt(0)==='#')return;
 if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button)return;
 var u;try{u=new URL(a.href)}catch(x){return}
 if(u.origin!==location.origin)return;
 if(a.closest('[data-cart-target]'))return;
 e.preventDefault();
 if(main){main.classList.remove('pg-in');main.classList.add('pg-out')}
 setTimeout(function(){location.href=a.href},170);
});
})();

/* ===== v2.6: Scroll-Bake + Hero-Dampf & Parallax ===== */
(function(){
var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
var bakeOn=document.body.getAttribute('data-fx-bake')!=='0';
var heroOn=document.body.getAttribute('data-fx-hero')!=='0';
var sp=document.getElementById('scrollProg');
var hero=document.querySelector('.hero');
var media=hero?hero.querySelector('video,.hero-img'):null;
if(heroOn&&hero&&!reduce){var st=document.createElement('div');st.className='hero-steam';
 st.innerHTML='<i></i><i></i><i></i>';
 hero.insertBefore(st,hero.querySelector('.hero-inner'));}
var raf=null;
function frame(){raf=null;
 var h=document.documentElement,p=h.scrollTop/((h.scrollHeight-h.clientHeight)||1);
 if(bakeOn&&sp){sp.style.setProperty('--bake',Math.min(1,p*1.02).toFixed(3));
  sp.classList.toggle('done',p>=.985);}
 if(heroOn&&media&&!reduce){var y=Math.min(scrollY,innerHeight);
  media.style.setProperty('--par',(y*.14).toFixed(1)+'px');}}
addEventListener('scroll',function(){if(!raf)raf=requestAnimationFrame(frame)},{passive:true});
frame();
})();

/* ===== v2.7: Editorial + City-Theming ===== */
(function(){
var B=document.body;
var CITY={'monaco':'#D9B262','vienna':'#EAD9B8','wien':'#EAD9B8','paris':'#B34A5E','havana':'#4E9B63','milan':'#7C9A5C','milano':'#7C9A5C','barcelona':'#E0863C','madrid':'#C24A3A','nizza':'#6FB1C9','nice':'#6FB1C9','new york':'#6C7A93','newyork':'#6C7A93','buenos aires':'#8E6FB0','london':'#5E6FA3','tokio':'#C77CA0'};
function findCity(t){t=(t||'').toLowerCase();for(var k in CITY){if(t.indexOf(k)>=0)return CITY[k]}return null}
/* Nº-Wasserzeichen (nur Startseite) */
if(B.getAttribute('data-fx-editorial')!=='0'&&B.getAttribute('data-tpl')==='index'){
 var secs=document.querySelectorAll('#MainContent .shopify-section, main>section, main>.shopify-section');
 var n=0;secs.forEach(function(w){var s=w.matches('section')?w:w.querySelector('section');if(!s||s.dataset.no)return;
  s.dataset.no='1';n++;s.classList.add('has-no');
  var e=document.createElement('span');e.className='sec-no';e.setAttribute('aria-hidden','true');
  e.textContent='Nº'+String(n).padStart(2,'0');s.appendChild(e);});
 /* Gold-Foil auf Schlüsselwörter */
 var WORDS=['Legenden','Drop','Club','Regeln','Charaktere','Städte','Gutschein'];
 document.querySelectorAll('main h1, main h2').forEach(function(h){
  h.childNodes.forEach(function(nd){if(nd.nodeType!==3)return;var t=nd.textContent,hit=null;
   WORDS.forEach(function(w){if(!hit&&t.indexOf(w)>=0)hit=w});
   if(!hit)return;var sp=document.createElement('span');
   sp.innerHTML=t.replace(hit,'<span class="foil">'+hit+'</span>');nd.replaceWith(sp);});});
}
/* City-Theming */
if(B.getAttribute('data-fx-city')!=='0'){
 var R=document.documentElement,off=null;
 function on(col){R.style.setProperty('--accent-city',col)}
 function offSoon(){}
 document.addEventListener('pointerover',function(e){var c=e.target.closest('.ed');if(!c)return;
  var col=findCity(c.textContent);if(!col)return;c.classList.add('city-hot');c.style.setProperty('--accent-city',col);on(col)});
 document.addEventListener('pointerout',function(e){var c=e.target.closest('.ed');if(!c)return;
  c.classList.remove('city-hot');offSoon()});
 if(B.getAttribute('data-tpl')==='product'){
  var k=document.querySelector('.pdp .kicker, .pdp-sub, .pdp h1');
  var col=k?findCity(k.textContent):null;
  if(col){R.style.setProperty('--accent-city',col);}
 }
}
})();
